// Components==============
import {
    faCalendar,
    faClock,
    faEnvelope,
    faGlobeEurope,
    faMapMarkerAlt,
    faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button';
import Modal from 'components/UI/Modal';
import RichText from 'components/UI/RichText';
import React from 'react';
import { useSelector } from 'react-redux';
import { getActivityBackground } from 'utilities/getActivityBackground';
import { getDateString } from 'utilities/getDateString';
import { getLink } from 'utilities/getLink';
import './ActivityModal.module.scss';

// =========================

export default function ActivityModal({ activity }) {
    const school = useSelector(
        (state) => state.school.entities.byId?.[activity?.school_id]
    );

    const color = getActivityBackground(activity, true);

    console.log(activity);
    const labels = [
        {
            name: 'Website',
            icon: faGlobeEurope,
            value: school?.contact?.website,
        },
        {
            name: 'Datum activiteit',
            icon: faCalendar,
            value: activity ? getDateString(activity?.convertedDate) : '',
        },
        {
            name: 'Tijd',
            icon: faClock,
            value: activity?.time,
        },
        {
            name: 'Locatie',
            icon: faMapMarkerAlt,
            value: activity?.location,
        },
    ];

    return (
        <Modal
            color={color.hex}
            image={activity?.image}
            slug={`activity-popup/${activity?.id}`}
        >
            <div styleName="content">
                <div styleName="top">
                    <div styleName="left">
                        <h3 style={{ color: color?.hex }}>{activity?.name}</h3>
                        {!!school?.name && (
                            <p style={{ color: color?.hex }}>{school?.name}</p>
                        )}
                    </div>
                    {!!school?.logo && (
                        <img src={school?.logo} alt={school?.name} />
                    )}
                </div>
                <div styleName="labels">
                    {labels.map(
                        (label) =>
                            !!label?.value && (
                                <div styleName="label" key={label?.name}>
                                    <p styleName="title">
                                        {label.name}{' '}
                                        <FontAwesomeIcon icon={label?.icon} />
                                    </p>
                                    {label?.name === 'Website' ? (
                                        <a
                                            href={label?.value}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {label?.value.replace(
                                                /(^\w+:|^)\/\//,
                                                ''
                                            )}
                                        </a>
                                    ) : (
                                        <p>{label?.value}</p>
                                    )}
                                </div>
                            )
                    )}
                </div>

                <div styleName="button-wrapper">
                    {!!activity?.subscribe_link && (
                        <a
                            href={getLink(activity?.subscribe_link)}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Button color={color.name}>
                                Aanmelden activiteit{' '}
                                <FontAwesomeIcon icon={faUsers} />
                            </Button>
                        </a>
                    )}
                    {!!activity?.mail && (
                        <a href={`mailto:${activity?.mail}`}>
                            <Button color={color.name}>
                                Contact <FontAwesomeIcon icon={faEnvelope} />
                            </Button>
                        </a>
                    )}
                </div>
                <div styleName="divider" style={{ background: color.hex }} />
                <div styleName="bottom">
                    <RichText
                        richText={[
                            {
                                layout: 'text',
                                attributes: {
                                    text: activity?.description,
                                },
                            },
                        ]}
                    />
                    {activity?.html ? (
                        <RichText
                            richText={[
                                {
                                    layout: 'code',
                                    attributes: {
                                        code: activity?.html,
                                    },
                                },
                            ]}
                        />
                    ) : null}
                </div>
            </div>
        </Modal>
    );
}
